import { render, staticRenderFns } from "./BienDetailsMobileHeader.vue?vue&type=template&id=328c4fce"
import script from "./BienDetailsMobileHeader.vue?vue&type=script&lang=js"
export * from "./BienDetailsMobileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports